import { Injectable } from '@angular/core';

@Injectable()
export class StaticService {

  DEFAULT_project_type= [
    'Viviendas',
    'Hospitales y clínicas',
    'Centro de salud',
    'Hotel (5 estrellas)',
    'Hotel (4 estrellas)',
    'Hotel (3 estrellas)',
    'Hostal (2 estrellas)',
    'Camping',
    'Hostal (1 estrella)',
    'Residencia',
    'Centro penitenciario',
    'Albergue',
    'Vestuario',
    'Escuela sin ducha',
    'Escuela con ducha',
    'Cuartel',
    'Fábrica y taller',
    'Oficina',
    'Gimnasio',
    'Restaurante',
    'Cafetería'
  ];

	DEFAULT_project_unit = [
    "Personas",
    "Camas",
    "Camas",
    "Camas",
    "Camas",
    "Camas",
    "Camas",
    "Plazas",
    "Camas",
    "Camas",
    "Personas",
    "Camas",
    "Servicios",
    "Alumnos",
    "Alumnos",
    "Personas",
    "Personas",
    "Personas",
    "Usuarios",
    "Comidas",
    "Almuerzos"
  ];
  //volumen de agua necesario para un proyecto
  DEFAULT_volumen_project_type = new Array(28,55,41,69,55,41,34,21,28,41,28,24,21,4,21,28,21,2,21,8,1);

  DEFAULT_param = {
    project: "",
    selectedProvince: 'Barcelona',
    city: "",
    address: "",
    units:'Personas',
    tipovivienda: 2,
    num_unidades:  5,
    num_ocupantes: 15,
    volumen: 28,
    default_volumen: 28,
    accumulation: 150,
    centralization: 100,
    selectedProjectType: 'Viviendas',
    desviacion: 0,
    inclinacion: 40,
    contribucion: 50,
    contribucion_default: 0,
    temperatura_deseada: 60,
    perdidas: 0,
    zona: '',
    litros_dia: 420,
    selected_normativa: true,
  };

  zone = 'I';

  active_normativa = true;

  DEFAULT_accumulations = [100,150,200,250,300,350,400,450,500,1000,1500,2000,2500,3000,3500,4000,4500,5000,5500,
  6000,6500,7000,7500,8000,8500,9000,9500,10000,10500,11000,11500,12000,12500,13000,14500,15000,15500,16000,16500,
  17000,18500,19000,19500,20000];

  DEFAULT_options_param = {
    c_plana: true,
    interacumulador: true,
    forzado: true
  };

  DEFAULT_captador_param = {
    selectedCaptador: null,
    number: 1,
    accumulation: 150
  };


  loadedOffer = null;
  adminview = false;
  alloffers = [];
  allusers = [];
  selected_normativa = true; //2019

  constructor() { }


  getDefaultProjectType(){
    return JSON.parse(JSON.stringify(this.DEFAULT_project_type));
  }
  getDefaultProjectUnit(){
    return JSON.parse(JSON.stringify(this.DEFAULT_project_unit));
  }
  getDefaultParam(){
    return JSON.parse(JSON.stringify(this.DEFAULT_param));
  }
  getDefaultVolumenType(){
    return JSON.parse(JSON.stringify(this.DEFAULT_volumen_project_type));
  }
  getDefaultAccumulations(){
    return JSON.parse(JSON.stringify(this.DEFAULT_accumulations));
  }
  getDefaultOptionsParam(){
    return JSON.parse(JSON.stringify(this.DEFAULT_options_param));
  }
  getDefaultCaptadorParam(){
    return JSON.parse(JSON.stringify(this.DEFAULT_captador_param));
  }


  selectOffer(offer){
    this.loadedOffer = offer;
    console.log(this.loadedOffer);
  }

  unloadOffer(){
    this.loadedOffer = null;
  }

  setAdminView(admin){
    this.adminview = admin;
  }

  getAdminView(){
    return this.adminview;
  }

  getSelectedOffer(){
    return this.loadedOffer;
  }

  setZone(zone){
    this.zone = zone;
  }

  getZone(){
    return this.zone;
  }

  setNormativa(normativa){
    this.active_normativa = normativa;
  }

  getNormativa(){
    return this.active_normativa;
  }

  setAllOffers(offers){
    this.alloffers = [];
    for (var i=0; i < offers.length; i++)
      if(offers[i].client && offers[i].client != 19)
        this.alloffers.push(offers[i]);
    this.alloffers.sort(function(a, b) {
      var keyA = a.id,
        keyB = b.id;
      if (keyA < keyB) return 1;
      if (keyA > keyB) return -1;
      return 0;
    });
    this.checkOffers();
    console.log(this.alloffers);
  }

  getAllOffers(){
    return this.alloffers;
  }

  setAllUsers(users){
    this.allusers = users;
    for (var i = 0; i < this.allusers.length; i++)
      this.allusers[i].nb_offers = 0;
    this.allusers.sort(function(a, b) {
      var keyA = a.id,
        keyB = b.id;
      if (keyA < keyB) return 1;
      if (keyA > keyB) return -1;
      return 0;
    });
    console.log(this.allusers);
    this.checkOffers();
  }

  getAllUsers(){
    return this.allusers;
  }

  checkOffers(){
    if (this.alloffers.length > 0 && this.allusers.length > 0)
      for (var i = 0; i < this.alloffers.length; i++){
        var client = this.alloffers[i].client;
        var user = "";
        for (var j=0; j < this.allusers.length; j++)
          if (this.allusers[j].id == client){
            this.allusers[j].nb_offers = this.allusers[j].nb_offers + 1;
            user = this.allusers[j].company;
            break;
          }
        if (user.length > 0)
          this.alloffers[i].client = user;
      }
  }


}



// WEBPACK FOOTER //
// ./src/app/consulta/static.service.ts